import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './mathsubject.css';

const StudentPage = () => {

    return(
        <div className="subjectbox-1">
            <div className="subjectsidebar-4" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                <Link to={`/teacher/student/studentconfirm`}>
                    <h5>선생님 등록 확인 및 취소</h5>
                </Link>
            </div>
        </div>
    )
}

export default StudentPage;